import React from "react";
import PropTypes from "prop-types";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import Table from "examples/Tables/Table";
import { Card } from "@mui/material";
import EventNoteIcon from "@mui/icons-material/EventNote";

// Argon Dashboard 2 MUI examples
import Footer from "examples/Footer";

import { useState, useEffect } from "react";

import TutoProfileCard from "./TutoProfileCard";
import AttendanceTableData from "Views/Activities/AllAttendance/data/AttendanceTableData";
import axios from "utils/api";

function BasicDetails({ tutorId }) {
  const [attendanceData, setAttendanceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAttendance = async () => {
      if (!tutorId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await axios.get(`/attendance?tutorId=${tutorId}`);
        if (response.data.success) {
          setAttendanceData(response.data.data);
        } else {
          setError("Failed to fetch attendance data");
        }
      } catch (err) {
        console.error("Error fetching attendance:", err);
        setError("Error fetching attendance data");
      } finally {
        setLoading(false);
      }
    };

    fetchAttendance();
  }, [tutorId]);

  const { columns, rows } = AttendanceTableData(
    () => {},
    () => {},
    attendanceData
  );

  if (loading) {
    return (
      <ArgonBox>
        <Card sx={{ p: 5 }}>
          <ArgonBox
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap={2}
          >
            <ArgonTypography variant="h6" color="text">
              Loading Attendance Data...
            </ArgonTypography>
          </ArgonBox>
        </Card>
      </ArgonBox>
    );
  }

  if (error) {
    return (
      <ArgonBox>
        <Card sx={{ p: 5 }}>
          <ArgonBox
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap={2}
          >
            <EventNoteIcon sx={{ fontSize: 64, color: "#d0d0d0" }} />
            <ArgonTypography variant="h6" color="error">
              {error}
            </ArgonTypography>
          </ArgonBox>
        </Card>
      </ArgonBox>
    );
  }

  if (rows.length === 0) {
    return (
      <ArgonBox>
        <Card sx={{ p: 5 }}>
          <ArgonBox
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap={2}
          >
            <EventNoteIcon sx={{ fontSize: 64, color: "#d0d0d0" }} />
            <ArgonTypography variant="h6" color="text">
              No Attendance Data Available
            </ArgonTypography>
            <ArgonTypography variant="caption" color="text" textAlign="center">
              This tutor hasn&apos;t recorded any student attendance yet.
            </ArgonTypography>
          </ArgonBox>
        </Card>
      </ArgonBox>
    );
  }

  return (
    <ArgonBox>
      {/* <TutoProfileCard/> */}
      <ArgonBox
        mt={5}
        sx={{
          "& .MuiTableRow-root:not(:last-child)": {
            "& td": {
              borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                `${borderWidth[1]} solid ${borderColor}`,
            },
          },
        }}
      >
        <Table columns={columns} rows={rows} />
      </ArgonBox>
    </ArgonBox>
  );
}

BasicDetails.propTypes = {
  tutorId: PropTypes.string.isRequired,
};

export default BasicDetails;
